import { render, staticRenderFns } from "./CategoriesDialog.vue?vue&type=template&id=a515aea8&scoped=true&"
import script from "./CategoriesDialog.vue?vue&type=script&lang=js&"
export * from "./CategoriesDialog.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesDialog.vue?vue&type=style&index=0&id=a515aea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a515aea8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VList,VVirtualScroll})
